import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import {
  ChangeDetectorRef,
  DestroyRef,
  PLATFORM_ID,
  inject
} from '@angular/core';

export abstract class BaseLibComponent {
  protected _destroyRef = inject(DestroyRef);
  protected _cdRef = inject(ChangeDetectorRef);
  protected _platformId = inject(PLATFORM_ID);
  protected _document = inject(DOCUMENT);

  protected get _isPlatformBrowser(): boolean {
    return isPlatformBrowser(this._platformId);
  }

  protected get _isPlatformServer(): boolean {
    return isPlatformServer(this._platformId);
  }
}
